import React from "react";
import {
  BrowserRouter,
  HashRouter,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Index from "../pages/index";
// import Home from "../pages/home/index";
// import Login from "../manage/login/index";
// import Manage from "../manage/index";

export default class Router extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route
            path="/index/:code/:number"
            component={Index}
          />
          {/* <Route path="/home/index" component={Home} />
                    {<Route path="/manage" component={Manage} />}
                    <Route path="/login" component={Login} /> */}
          {/* <Route path="/xx/xx/:id" component={xxxxx} /> */}
          <Redirect to="/index/:code/:number" />
        </Switch>
      </HashRouter>
    );
  }
}
